/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

export default [
  {
    name: routeNames.WATER_ACCESS,
    path: 'water-access',
    component: () => import('@/fish/components/water-access/water-access-card'),
    children: [
      {
        name: routeNames.WATER_ACCESS_SITE,
        path: 'site/:id',
        redirect: { name: routeNames.WATER_ACCESS_SITE_OVERVIEW },
        component: () => import('@/fish/components/water-access/water-access'),
        children: [
          {
            name: routeNames.WATER_ACCESS_SITE_OVERVIEW,
            path: 'overview',
            component: () =>
              import('@/fish/components/water-access/water-access-overview'),
          },
          {
            name: routeNames.WATER_ACCESS_WEATHER,
            path: 'weather',
            component: () => import('@/components/weather/query-weather-tab'),
          },
        ],
      },
    ],
  },
]
